export default __webpack_public_path__ + "static/media/IMG_7383.d4f97257.jpg";